<template>
  <section
    class="app-downloads"
    aria-labelledby="app-downloads-title"
    data-cy="app-downloads"
  >
    <p id="app-downloads-title" class="download-title">
      {{ t('homePage.appDownloads.title') }}
    </p>
    <div class="store-actions">
      <a
        class="store-link"
        :href="play.href"
        :aria-label="t('homePage.appDownloads.googleLabel')"
        data-cy="google-play-download"
        @click="track('app_google_play_click')"
      >
        <img
          :src="play.badge"
          width="646"
          height="250"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </a>
      <div class="apple-slot">
        <button
          class="apple-coming"
          type="button"
          :aria-expanded="appleInfoOpen"
          aria-controls="apple-release-info"
          :aria-label="t('homePage.appDownloads.appleLabel')"
          data-cy="apple-coming-soon"
          @click="showAppleInfo"
        >
          <svg
            width="24"
            height="30"
            viewBox="0 0 24 30"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="4"
              y="1.5"
              width="16"
              height="27"
              rx="4"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M9 4h6M10 25h4"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <span
            ><span class="apple-name" lang="en" dir="ltr">App Store</span
            ><span class="coming-copy">{{
              t('homePage.appDownloads.comingSoon')
            }}</span></span
          >
        </button>
      </div>
    </div>
    <p
      v-if="appleInfoOpen"
      id="apple-release-info"
      class="apple-info"
      role="status"
    >
      {{ t('homePage.appDownloads.appleLabel') }}
    </p>
  </section>
</template>
<script setup>
import { storeDownload } from '~/utils/store-downloads';
const { locale, t } = useI18n();
const play = computed(() => storeDownload(locale.value));
const { track } = useConversionTracking();
const appleInfoOpen = ref(false);
function showAppleInfo() {
  appleInfoOpen.value = !appleInfoOpen.value;
  if (appleInfoOpen.value) track('app_apple_interest');
}
</script>
<style scoped>
.app-downloads {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgb(255 255 255 / 12%);
  text-align: center;
}
.download-title {
  margin: 0;
  color: #f3f4f6;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5;
  text-wrap: balance;
}
.store-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0 0.5rem;
  margin-top: 0.25rem;
}
.store-link,
.apple-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 232px;
  max-width: 100%;
  min-width: 0;
  aspect-ratio: 646/250;
}
.store-link {
  border-radius: 0.75rem;
  transition: background-color 150ms ease;
}
.store-link:hover {
  background: rgb(255 255 255 / 6%);
}
.store-link:focus-visible,
.apple-coming:focus-visible {
  outline: 3px solid #fb923c;
  outline-offset: 2px;
}
.store-link img {
  display: block;
  width: 100%;
  height: auto;
}
.apple-coming {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  width: 87%;
  min-height: 60px;
  padding: 0.5rem 0.75rem;
  border: 1px solid #52525b;
  border-radius: 0.5rem;
  background: #202024;
  color: #bfc1c8;
  text-align: start;
  cursor: pointer;
}
.apple-info {
  color: #bfc1c8;
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
}
.apple-coming svg {
  flex: none;
}
.apple-name {
  display: block;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.25;
}
.coming-copy {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.35;
  text-wrap: balance;
}
@media (prefers-reduced-motion: reduce) {
  .store-link {
    transition: none;
  }
}
</style>
